import { noop } from 'lodash';
import React, { Component, cloneElement } from 'react';
import ReactDOM from 'react-dom';
import './Modal.scss';
import If from '../If/If';
import {
  isDescendant,
  scrollElementIntoFullView,
} from '../../../utils/dom-utils';
import { moduleActions } from '../../../redux/modules';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { MdClear } from 'react-icons/md/index';

let defaultModalIdCounter = 0;

class Modal extends Component {
  constructor(props) {
    super(props);
    this.clickOutsideHandler = this.clickOutsideHandler.bind(this);
  }
  componentDidUpdate(prevProps) {
    const { onHide, onShow, show } = this.props;

    if (show && !prevProps.show && onShow) {
      onShow();
    }
    if (!show && prevProps.show && onHide) {
      onHide();
    }
  }
  defaultId = ++defaultModalIdCounter;
  clickOutsideHandler(event) {
    const { clickOutsideCloses = true, onCloseClick } = this.props;
    if (
      clickOutsideCloses &&
      !isDescendant(ReactDOM.findDOMNode(this).firstElementChild, event.target)
    ) {
      onCloseClick();
    }
  }

  render() {
    const {
      children,
      className = '',
      id = this.defaultId,
      onCloseClick = noop,
      show,
      showBackdrop = true,
      showCloseButton = true,
      dataAttributes = {},
    } = this.props;

    if (!show) {
      return null;
    }
    return (
      <div
        {...dataAttributes}
        data-metrics-location="PU"
        className={showBackdrop ? 'modal-backdrop' : ''}
        onClick={this.clickOutsideHandler}
      >
        <div className={showBackdrop ? `ssj-modal-content ${className}` : ''}>
          {React.Children.map(children, (child) =>
            cloneElement(child, this.props)
          )}

          <If test={showCloseButton}>
            <a
              id={`modal-close-${id}`}
              className={`modal-close e2e-modal-close-button`}
              onClick={onCloseClick}
            >
              <MdClear />
            </a>
          </If>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { rothConversionTransaction } = state;
  return {
    rothConversionTransaction,
  };
};
const mapDispatchToProps = (dispatch) => ({
  actions: {
    ...bindActionCreators(moduleActions, dispatch),
    setProgress: (step) => {
      scrollElementIntoFullView(`step${step}`);
      dispatch(moduleActions.setProgress(step));
    },
    onClickScroll: (step, element) => {
      dispatch(moduleActions.setProgress(step));
      scrollElementIntoFullView(element, 15);
    },
  },
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Modal);
